export default "__VITE_ASSET__tbN1p$NZ__"